import { useBucket } from '@mc/experiments-react'

export const CE_3448_CLARIFY_MULTIPLE_PROFILES_AT_SIGN_UP =
  'ce-3448-clarify-multiple-profiles-at-sign-up'

export const useSignUpEducation = () => {
  const bucket = useBucket(CE_3448_CLARIFY_MULTIPLE_PROFILES_AT_SIGN_UP)
  const isExperimentParticipant = !!bucket

  return {
    isExperimentParticipant,
    isVariant: bucket === 'variant_1',
  }
}
